import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import logo from '../assets/LOGO (2).png';

export default function NotFound() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <img
            src={logo}
            alt="Easy Survey Logo"
            className="mx-auto h-16 w-auto mb-4"
          />
          <h1 className="text-6xl font-bold text-teal-600">404</h1>
          <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900">
            Page non trouvée
          </h2>
          <p className="mt-2 text-center text-sm text-gray-600">
            La page que vous recherchez n'existe pas.
          </p>
          <div className="mt-6">
            <button
              onClick={() => navigate(-1)}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-teal-600 hover:bg-teal-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-teal-500"
            >
              <Home className="mr-2 h-4 w-4" />
              Retour vers la page précédente
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}